import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class MitsatTitleStrategy extends TitleStrategy {
    private readonly applicationName = 'Mitsat';

    constructor(private readonly title: Title) {
        super();
    }

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const pageTitle = this.buildTitle(snapshot);
        const documentTitle = pageTitle
            ? `${this.applicationName} - ${pageTitle}`
            : this.applicationName;

        this.title.setTitle(documentTitle);
    }
}
